import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
    HttpStatusCode,
} from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Observable, catchError } from 'rxjs';
import { ErrorHandlerService } from '../services/errorHandling.service';

@Injectable({ providedIn: 'root' })
export class HttpErrorInterceptor implements HttpInterceptor {
    constructor(private readonly injector: Injector) {}
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            catchError((httpError: HttpErrorResponse) => {
                const errorHandlerService = this.injector.get(ErrorHandlerService);
                if (httpError.status === HttpStatusCode.TooManyRequests && !errorHandlerService.isPopUpShown) {
                    errorHandlerService.openErrorDialog('aumico_dialog_error_too_many_requests');
                }
                throw httpError;
            }),
        );
    }
}
